<div>
  <div class="relative">
    <aux-route-tab-group class="absolute" [tabs]="tabs" [variant]="'button'" />
  </div>

  <router-outlet />
</div>
